import { useQuery } from "@tanstack/react-query";
import { buildUrl, toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";

import { AiAssistantEffectivePrompt } from "../../aiAgents.types";
import {
  AI_ASSISTANTS_QUERY_KEY,
  AiAssistantSubRoute,
  ApiRoutesAiAssistants
} from "../../constants/enums";

export const useGetEffectivePrompt = (assistantId: string | undefined) => {
  const query = useQuery<AiAssistantEffectivePrompt, ApiServiceError<ApiError>>(
    {
      queryKey: [
        AI_ASSISTANTS_QUERY_KEY,
        "effective-prompt",
        assistantId ?? ""
      ],
      queryFn: async () =>
        await instance.get(
          buildUrl(
            ApiRoutesAiAssistants.Assistants,
            assistantId!,
            AiAssistantSubRoute.EffectivePrompt
          )
        ),
      enabled: Boolean(assistantId),
      onError: toastServerError
    }
  );

  return { effectivePrompt: query.data ?? null, ...query };
};
